import { Backdrop, CircularProgress } from '@mui/material';

interface LoaderOverlayProps {
  active: boolean;
}
export const LoaderOverlay = ({ active }: LoaderOverlayProps) => (
  <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={active}>
    <CircularProgress color="inherit" />
  </Backdrop>
);
